// extracted by css-extract-rspack-plugin
export default {"QueryErrorTitle":"TL1bK","QueryErrorIcon":"jnxBg","QueryErrorMessage":"UxEnq","QueryErrorLink":"XgKvt"};